import { Pipe, PipeTransform } from "@angular/core";
import { detectPrecisionHelper, roundUpToHundredth } from "@modules/trade/helpers/helper";
import { Big } from "big.js";

@Pipe({
	name: "round",
	standalone: false
})
export class RoundingPipe implements PipeTransform {
	transform(value: string | number): number {
		return Math.round(+value);
	}
}

@Pipe({
	name: "round_with_precision",
	standalone: false
})
export class RoundingWithPrecisionPipe implements PipeTransform {
	transform(value: string | number, precision = 2): number {
		const factor = Math.pow(10, precision); // 2 is the number of decimal places
		const truncated = Math.floor(+value * factor) / factor;
		return truncated;
	}
}

@Pipe({
	name: "round_up_for_min_val_fiat",
	standalone: false
})
export class RoundingUpForMinValFiat implements PipeTransform {
	transform(value: string | number): number {
		return roundUpToHundredth(+value);
	}
}

@Pipe({
	name: "round_up_for_min_val",
	standalone: false
})
export class RoundingUpMinVal implements PipeTransform {
	transform(value: string | number): number {
		const _convert = new Big(value);
		const _decimalPlaces = detectPrecisionHelper(+_convert);
		detectPrecisionHelper(+_convert);

		return _convert.round(_decimalPlaces, Big.roundUp).toNumber();
	}
}
